<script setup>
import { ref } from 'vue'
import { useSeoMeta, useHead } from '@unhead/vue'
import { useGlobalStore } from '@stores/global'
import { useServiceStore } from '@stores/service'
import { useProjectStore } from '@stores/project'

import LoadingOverlay from '@components/global/LoadingOverlay.vue'
import Hero from '@sections/index/Hero.vue'
import TearDivider from '@components/global/accents/TearDivider.vue'
import Services from '@sections/global/Services.vue'
import Projects from '@sections/index/Projects.vue'
import Clients from '@sections/global/Clients.vue'
import Contact from '@sections/global/Contact.vue'

const global = useGlobalStore()
const service = useServiceStore()
const project = useProjectStore()
const videoReady = ref(false)

useSeoMeta({
	title: () => global.pages.find((page) => page.path === '/')?.title,
	description: () => global.pages.find((page) => page.path === '/')?.description,
	image: () => global.pages.find((page) => page.path === '/')?.image,
})

// useSeoMeta({
// 	title: 'Work',
// 	ogTitle: 'Work',
// })
// useHead({
// 	script: [
// 		{
// 			type: 'application/ld+json',
// 			innerHTML: {
// 				'@context': 'https://schema.org',
// 				'@graph': [
// 					{
// 						'@type': 'Organization',
// 						'@id': 'https://papercrowns.com/#organization',
// 						name: 'Paper Crowns',
// 						url: 'https://papercrowns.com',
// 						// logo: {
// 						// 	'@type': 'ImageObject',
// 						// 	url: 'https://papercrowns.com/images/logo.png',
// 						// },
// 						sameAs: ['https://www.linkedin.com/company/papercrowns', 'https://www.x.com/papercrowns', 'https://www.instagram.com/papercrowns'],
// 					},
// 					{
// 						'@type': 'BreadcrumbList',
// 						'@id': 'https://papercrowns.com/work/project-alpha#breadcrumbs',
// 						itemListElement: [
// 							{
// 								'@type': 'ListItem',
// 								position: 1,
// 								name: 'Work',
// 								item: 'https://papercrowns.com/work',
// 							},
// 							{
// 								'@type': 'ListItem',
// 								position: 2,
// 								name: 'Project Alpha',
// 								item: 'https://papercrowns.com/work/project-alpha',
// 							},
// 						],
// 					},
// 				],
// 			},
// 		},
// 	],
// })
</script>

<template>
	<main>
		<transition name="fade" mode="out-in">
			<LoadingOverlay v-if="!videoReady || global.clients.length === 0 || !service.ready || !project.ready" />
		</transition>
		<Hero @update:videoReady="videoReady = $event" />
		<template v-if="global.clients.length > 0 && service.ready && project.ready">
			<TearDivider paper="#080808" background="#111111" />
			<Services />
			<TearDivider paper="#111111" background="#080808" />
			<Projects />
			<TearDivider paper="#080808" background="#111111" />
			<Clients />
			<Contact />
		</template>
	</main>
</template>
